import { AxiosError, AxiosInstance } from 'axios';

export default (client: AxiosInstance) => {
  client.interceptors.request.use((config: any) => {

    return config;
  });

  client.interceptors.response.use(
    (res: any) => res.data,
    async (error: AxiosError) => {

      return Promise.reject(error);
    }
  );
};
